/**
 * Formats a phone number for WhatsApp usage
 * 
 * Rules:
 * - If number has 10 digits and no "+", add "+52" prefix (Mexico country code)
 * - Remove all non-numeric characters except "+" if it's at the beginning
 * - Sanitize spaces, parentheses, and other characters
 * 
 * @param {string} phoneNumber - The phone number to format
 * @returns {string} - Formatted phone number for WhatsApp
 */
export const formatPhoneForWhatsApp = (phoneNumber) => {
  if (!phoneNumber) {
    return '';
  }

  // Convert to string in case it's a number
  const phoneStr = String(phoneNumber).trim();
  
  // Check if the number starts with "+"
  const hasPlus = phoneStr.startsWith('+');
  
  // Remove all non-numeric characters except "+"
  // First, extract the "+" if it exists
  const plusPrefix = hasPlus ? '+' : '';
  
  // Remove all non-numeric characters
  const digitsOnly = phoneStr.replace(/\D/g, '');
  
  // If no plus and number has exactly 10 digits, add +52
  if (!hasPlus && digitsOnly.length === 10) {
    return `+52${digitsOnly}`;
  }
  
  // If plus exists, return plus + digits
  if (hasPlus) {
    return `${plusPrefix}${digitsOnly}`;
  }
  
  // Otherwise, return just the digits
  return digitsOnly;
};

/**
 * Masks an email address for privacy.
 * e.g. "juan@example.com" -> "j***@ex***.com"
 */
export const maskEmail = (email) => {
  if (!email) return 'No especificado';
  const [local, domain] = email.split('@');
  if (!domain) return `${email[0]}***`;
  const domainParts = domain.split('.');
  const tld = domainParts.pop();
  const maskedDomain = (domainParts.join('.') || domain)[0] + '***';
  const maskedLocal = (local[0] || '') + '***';
  return `${maskedLocal}@${maskedDomain}.${tld}`;
};

/**
 * Masks a phone number for privacy.
 * e.g. "5512345678" -> "551****"
 */
export const maskPhone = (phone) => {
  if (!phone) return 'No especificado';
  const digits = String(phone).replace(/\D/g, '');
  return `****${digits.slice(-4)}`;
};
